/**
 * client/src/lib/cta-classes.ts
 *
 * The ONE visual contract for a call-to-action control in the elevation
 * affordance — link or button, notice or arms list.
 *
 * Extracted out of `aal3-elevation-notice.tsx` (whole-branch review, Minor 1):
 * the notice imported `ElevationArmsList` and the list imported `CTA_CLASSES`
 * back from the notice, a genuine import cycle between two modules that render
 * one another. A shared constant with no React dependency has no business
 * living in a component file — this is its home, and both importers now point
 * here. Nothing re-exports it (G4: one source of truth, one import path).
 */
export const CTA_CLASSES =
  "min-h-[44px] inline-flex items-center gap-2 px-4 rounded-[var(--radius-md)] border border-border-default text-[length:var(--text-body-size)] font-semibold text-text-primary hover:border-interactive transition-colors duration-[var(--duration-fast)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-[var(--color-accent)] focus-visible:outline-offset-2 disabled:opacity-40 disabled:pointer-events-none";
